import { createFocusContainer, removeFocusContainer } from "../helpers-focus.js"
import { destoryItem } from "../utils.js";

/* Creates a focus container with the "alice" mini game where user has to choose between a wining 
 * and a losing button;
 */
function alice({ board, gameState, handleGameOver }) {
  return new Promise((resolve) => {

    const focusContainer = createFocusContainer({ board });
    const leftButton = document.createElement("button");
    const rightButton = document.createElement("button");
    leftButton.innerText = "Eat me";
    rightButton.innerText = "Drink me";
    focusContainer.classList.add("alice");
    focusContainer.appendChild(leftButton);
    focusContainer.appendChild(rightButton);


    const [winningButton, losingButton] = Math.random() <= .5
      ? [leftButton, rightButton]
      : [rightButton, leftButton];
    //TODO: Maybe remove?
    winningButton.classList.add("winner");

    winningButton.addEventListener('click', handleAliceWin);
    losingButton.addEventListener('click', handleAliceLose);

    function handleAliceWin() {
      removeFocusContainer(focusContainer, { board })
      resolve();
    }

    function handleAliceLose() {
      gameState.clicks = gameState.maxClicks;
      gameState.gameOver = true;
      gameState.gameOverReason = "alice";
      removeFocusContainer(focusContainer, { board })
      // handleGameOver("alice");
      resolve();
    }
  });
}

export default alice;
